/* eslint-disable */
import Wheel from '@/pure/Wheel'
import Touch from '@/pure/Touch'
import Keyboard from '@/pure/Keyboard'

export default
{
    created()
    {
        this.wheel = new Wheel({
            onDown: this.onNext,
            onTop: this.onPrev
        })

        this.touch = new Touch({
            onDown: this.onNext,
            onTop: this.onPrev
        })

        this.keyboard = new Keyboard()
        this.keyboard.onUp('ArrowUp', this.onPrev)
        this.keyboard.onUp('ArrowDown', this.onNext)

        this.keyboard.onUp('ArrowLeft', this.onPrev)
        this.keyboard.onUp('ArrowRight', this.onNext)

        this.keyboard.onUp('Home', this.onPrev)
        this.keyboard.onUp('End', this.onNext)

        this.keyboard.onUp('PageUp', this.onPrev)
        this.keyboard.onUp('PageDown', this.onNext)
    },

    destroyed()
    {
        if (this.wheel)
        {
            this.wheel.dispose()
        }

        if (this.touch)
        {
            this.touch.dispose()
        }

        if (this.keyboard)
        {
            this.keyboard.dispose()
        }
    },

    methods:
    {
        onPrev()
        {
            this.$emit('prev')
        },

        onNext()
        {
            this.$emit('next')
        }
    }
}
